import http from '../../src/api/axiosConfig'

class ManageEarn {

    prefix = '/v1/web/earn/'

    loadAllEarns() {
        return http.get(this.prefix + 'all')
    }

    getClientEarns(clientId) {
        return http.get(this.prefix + 'get/' + clientId)
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageEarn()
